import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

export type Crumb = { to?: string; label: ReactNode };

/** Breadcrumb row matching .crumbs / .sep design tokens. */
export default function Crumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <div className="crumbs">
      {crumbs.map((c, i) => (
        <span key={i}>
          {c.to ? <Link to={c.to}>{c.label}</Link> : c.label}
          {i < crumbs.length - 1 && <span className="sep">/</span>}
        </span>
      ))}
    </div>
  );
}
